<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Informar</span>
        </v-col>
        <!-- <v-col cols="2" class="pt-1">
                    <v-btn v-if="this.$hasPermision('laboratorio-informar.create')" dark color="#023145" width="140" class="float-right" @click="handleShowCreate">
                        Nuevo
                    </v-btn>
                </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_prosecution"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="4" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>

        <!-- <v-col cols="0" class="pt-1">
                    <v-btn dark
                        class="float-left ml-1"
                        color="green"
                        @click="handleViewDownload">
                        Importar
                    </v-btn>
                </v-col> -->

        <!-- <v-col cols="4">
                    <v-btn dark
                        class="float-right ml-2"
                        color="green"
                        @click="handleViewDownload">
                        Importar
                    </v-btn>
                    <v-btn v-if="this.$hasPermision('laboratorio-informar.filters')" dark color="#023145" outlined width="140" class="float-right" @click="handleShowFilters">
                        <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
                        Ver Filtros
                    </v-btn>
                </v-col> -->

        <!-- <v-col cols="2" class="pt-1">
                    <v-btn v-if="this.$hasPermision('laboratorio-informar.filters')" dark color="#023145" outlined width="140" class="float-right" @click="handleShowFilters">
                        <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
                        Ver Filtros
                    </v-btn>
                </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="prosecutions"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todo los Informes
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.customer_fullname="{ item }">
                <span class="font-weight-medium">{{
                  item.customer_surname + " " + item.customer_name
                }}</span>
                <!-- <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span> -->
              </template>

              <template v-slot:item.state_report="{ item }">
                <span
                  v-if="item.state_report == 'sin informar'"
                  style="color:#F44336; display:flex; margin-left:50px; border:2px solid; padding: 0 5px; width:max-content; border-radius:5px;"
                >
                  {{ item.state_report }}
                </span>
                <span
                  v-if="item.state_report == 'confirmado'"
                  style="color:#00C706; display:flex; margin-left:50px; border:2px solid; padding: 0 5px; width:max-content; border-radius:5px;"
                >
                  {{ item.state_report }}
                </span>
                <span
                  v-if="item.state_report == 'informado'"
                  style="color:#001FFE; display:flex; margin-left:50px; border:2px solid; padding: 0 5px; width:max-content; border-radius:5px;"
                >
                  {{ item.state_report }}
                </span>
                <span
                  v-if="item.state_report == null"
                  class=""
                  style="color:#F44336; display:flex; margin-left:50px; border:2px solid; padding: 0 5px; width:max-content; border-radius:5px;"
                >
                  sin informar
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <v-btn
              v-if="
                show_btn_active_informar != 'confirmado' &&
                  this.$hasPermision('laboratorio-informar.edit')
              "
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn>
            <!-- <v-btn v-if="show_btn_active && this.$hasPermision('laboratorio-informar.change_status')" class="ml-4 mt-3" dark color="green" outlined @click="handleChangeStatus">
                            <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
                            Activar
                        </v-btn>
                        <v-btn v-if="!show_btn_active && this.$hasPermision('laboratorio-informar.change_status')" class="ml-4 mt-3" dark color="amber" outlined @click="handleChangeStatus">
                            <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
                            Inactivar
                        </v-btn> -->
            <v-btn
              v-if="
                show_btn_active_informar == 'informado' &&
                  this.$hasPermision('laboratorio-informar.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleConfirmado"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Confirmar
            </v-btn>
            <v-btn
              v-if="
                show_btn_active_informar == 'confirmado' &&
                  this.$hasPermision('laboratorio-informar.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleConfirmado"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              No Confirmar
            </v-btn>
            <!-- <v-btn v-if="this.$hasPermision('laboratorio-informar.destroy')" class="ml-4 mt-3" dark color="red" outlined @click="handleDelete">
                            <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
                            Eliminar
                        </v-btn> -->
            <v-btn
              class="ml-4 mt-3"
              dark
              color="blue"
              outlined
              @click="changeGeneratePdf(true)"
            >
              <v-icon class="mr-2" size="16">fa-solid fa-file-pdf</v-icon>
              Informe con Diseño
            </v-btn>
            <v-btn
              class="ml-4 mt-3"
              dark
              color="blue"
              outlined
              @click="changeGeneratePdf(false)"
            >
              <v-icon class="mr-2" size="16">fa-solid fa-file-pdf</v-icon>
              Informe sin Diseño
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <create-update ref="createUpdate"></create-update>
    <Filters ref="filters"></Filters>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/informar/CreateUpdate";
import Filters from "../../../components/informar/Filters";

import JQuery from "jquery";
import TicketTools from "../../../helpers/TicketTools";
import InformarTools from "../../../helpers/InformarTools";
import InformarToolsTomolab from "../../../helpers/InformarToolsTomolab";
let $ = JQuery;
import axios from "axios";

export default {
  name: "Report",
  components: {
    CreateUpdate,
    Filters,
    OfficeLogin,
  },
  data() {
    return {
      search_prosecution: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: null,
      show_btn_active_informar: true,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Registros",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "PACIENTE", value: "customer_fullname" },
        { text: "ORDEN DE TRABAJO", value: "order_code" },
        { text: "FECHA DE REGISTRO", value: "date" },
        { text: "ESTADO", value: "state_report" },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getProsecution({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("informar", ["prosecutions", "generate_pdf", "paginated"]),
    ...mapState("authentication", ["office_id"]),
  },
  methods: {
    ...mapActions("informar", [
      "getProsecution",
      "change_status",
      "delete",
      "newProsecutions",
      "change_status_confirmado",
      "generatePdf",
    ]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
      if (this.selectedRows.length > 0) {
        this.show_btn_active_informar = this.selectedRows[0].state_report;
        // console.log("btn de change informar === >>>>", this.show_btn_active_informar)
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nueva marca", "create");
    },
    handleEdit() {
      let procesamiento = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Informar Orden",
        "update",
        procesamiento
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de marcas");
    },
    async getAllProsecutions() {
      await this.getProsecution();
      this.parseDataProsecution();
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {};
      if (this.search_prosecution.length > 0) {
        if (!isNaN(this.search_prosecution)) {
          // ? search dni or order
          if (this.search_prosecution.length < 6) {
            filters = { ...filters, order_code: this.search_prosecution };
          } else {
            filters = { ...filters, dni: this.search_prosecution };
          }
        } else {
          // ? search for name
          filters = {
            fullname: this.search_prosecution,
          };
        }
        // ! add office_id for search
        // if(this.office_id != null) filters = { ...filters, office_id:this.office_id}
      }
      await this.getProsecution(filters);
      this.parseDataProsecution();
    },
    async handleChangeStatus() {
      let prosecution = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(prosecution);
    },
    async handleConfirmado() {
      let prosecution = this.selectedRows[0];
      await this.change_status_confirmado(prosecution);
    },
    async handleDelete() {
      let prosecution = this.selectedRows[0];
      await this.delete(prosecution);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    parseDataProsecution() {
      const newValue = [];
      this.prosecutions.map((value) => {
        const date = new Date(value.date_process);
        const month =
          date.getMonth().toString.length == 1
            ? "0" + date.getMonth()
            : date.getMonth();
        const day =
          Number(date.getDate()) < 10 ? "0" + date.getDate() : date.getDate();
        newValue.push({
          ...value,
          date: date.getFullYear() + "-" + month + "-" + day,
        });
      });

      this.newProsecutions(newValue);
    },

    async changeGeneratePdf(diseño) {
      await this.generatePdf({
        id: this.selectedRows[0].id,
        office_id: this.office_id,
      });
      await this.handlePrintVoucher(this.generate_pdf, diseño);
    },
    async handlePrintVoucher(response, diseño) {
      if (response) {
        // const routeFile = response.procesamiento.routeFile;
        // const nameFile = response.procesamiento.nameFile;
        // if (routeFile.length > 0 && nameFile.length > 0) {
        //   const imagen_url =
        //     process.env.VUE_APP_API_URL_BASE + "/" + routeFile + nameFile;
        //   let image = await axios.get(imagen_url, {
        //     responseType: "blob",
        //     headers: { "Access-Control-Allow-Origin": "*" },
        //   });
        // }
        let content = null;
        if (diseño)
          content = InformarToolsTomolab.printInformarNewDisenio(response);
        else content = InformarToolsTomolab.printInformarSinDisenio(response);

        this.printVoucher(content);
      }
    },

    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();

      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 1200);
      setTimeout(() => {
        $(".printFrame").remove();
      }, 1400);
    },
  },
  created() {
    this.getAllProsecutions();
  },
};
</script>

<style scoped></style>
